import { TApplicationState } from '../../types/redux';

export const getFullUrl = (state: TApplicationState) => {
  return state.fullUrl;
};
